import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { whyRythugaru } from "@/mocks/siteData";

export default function WhyRythugaruSection() {
  return (
    <section className="sun-glaze bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              The Rythugaru Way
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            Why Rythugaru?
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {whyRythugaru.map((item, index) => (
            <Reveal key={item.title} delay={(index % 3) * 90}>
              <div className="h-full bg-background-50 rounded-lg border border-background-200 p-7 flex flex-col">
                <span className="text-3xl">{item.emoji}</span>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-950 font-semibold mt-5">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3 flex-1">
                  {item.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}